import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { Field, Form } from 'redux-form'
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup"
import withForm from 'with/Form'

import TextField from 'components/TextField'
import Button from 'components/buttons/Button'

import schema from './schema'
import styles from './index.css'

@withForm({
  asyncValidate : asyncValidate(schema),
  shouldAsyncValidate
})
export default class LoginForm extends React.Component {
  
  static propTypes = {
    form     : PropTypes.string.isRequired,
    onSubmit : PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <Form onSubmit={handleSubmit}>
        <div className={styles.Header}>
          <h1>Login</h1>

          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
            <g fill="none" fillRule="evenodd">
                <path d="M-6-4h32v32H-6z"/>
                <path fill="#FF565C" d="M9.92.003a.883.883 0 0 0-.26.07L.519 3.961A.838.838 0 0 0 0 4.729c0 6.027.37 9.532 1.821 12.243 1.451 2.71 3.893 4.416 7.706 6.889.287.185.66.185.946 0 3.813-2.473 6.255-4.178 7.706-6.889C19.629 14.262 20 10.756 20 4.729a.84.84 0 0 0-.518-.767L10.34.072a.891.891 0 0 0-.42-.07zM7.714 5.304l.572 8.372h3.428l.572-8.372H7.714zm.572 9.488v3.348h3.428v-3.348H8.286z"/>
            </g>
          </svg>
        </div>
        <br/>
        <Field 
          name='email' 
          label='Email'
          type='email'
          component={TextField} 
          />
        <Field 
          name='password' 
          label='Password'
          type='password'
          component={TextField} 
          />
        <NavLink 
          style={{  
            fontFamily: 'Roboto',
            fontSize: '1.6rem',
            lineHeight: '1.5',
            color: '#f24f12'
          }}
          to='/forgotPassword'>
          Forgot Password
        </NavLink>
        <br/><br/>
        <Button 
          loading={this.props.submitting}
          type='submit'
          color='orange' 
          style={{margin: '2rem 0rem'}}>
          Login
        </Button>
      </Form>
    )
  }

}



// WEBPACK FOOTER //
// ./src/forms/LoginForm/index.jsx